var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"w-full h-auto flex flex-row",class:[
    'px-6',
    'sm:px-6',
    'md:px-24',
    'lg:px-40'
  ]},'div',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }